module.exports = __webpack_public_path__ + "images/49842e5fa6408c022191d4e258c6d3da-level4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/level4.png
// module id = 1027
// module chunks = 0